import { useEffect, useState } from "react";

export interface ICountdownParts {
  d: number;
  h: number;
  m: number;
  s: number;
}

export const pad = (n: number): string => String(n).padStart(2, "0");

const getCountdownParts = (targetDate: string): ICountdownParts => {
  const diff = new Date(targetDate).getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff % 86400000) / 3600000),
    m: Math.floor((diff % 3600000) / 60000),
    s: Math.floor((diff % 60000) / 1000),
  };
};

// Ticks every second — shared by the competition detail page's countdown
// strip and the activity feed's on-image countdown widget so both render the
// identical D:H:M:S breakdown.
export const useCountdownParts = (targetDate: string): ICountdownParts => {
  const [time, setTime] = useState(() => getCountdownParts(targetDate));

  useEffect(() => {
    const id = setInterval(() => setTime(getCountdownParts(targetDate)), 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  return time;
};
